import React from "react";
import styled from "styled-components";
import {
  DateRangePicker as MuiDateRangePicker,
  LocalizationProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@material-ui/pickers/adapter/date-fns";
import { he } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import dateImg from "../../assets/img/date.svg";

const Label = styled.label(({ theme }) => ({
  textAlign: "right",
  fontSize: 18,
  color: theme.color.text,
  display: "flex",
  alignItems: "center",
  marginInlineEnd: "1em",
}));

const TillDateLabel = styled.label(({ theme }) => ({
  background: "rgba(214,215,223,1)",
  color: "rgba(74,105,166,1)",
  fontWeight: 600,
  fontSize: 17,
  textAlign: "start",
  padding: "0.7em",
  height: "100%",
}));

const StyledMuiDateRangePicker = styled(MuiDateRangePicker)(
  ({ theme }) => ({})
);

const StyledInputDate = styled(TextField)(({ theme }) => ({
  "&&": {
    ".MuiOutlinedInput-root": {
      boxSizing: "border-box",
      boxShadow: "none",
      border: 0,
      lineHeight: 1,
    },
    ".MuiOutlinedInput-notchedOutline": {
      border: 0,
      lineHeight: 1,
    },
  },
}));

const DateRangePicker = ({ handleDateChange, ...props }) => {
  const { t } = useTranslation("common");
  const [selectedDate, setSelectedDate] = React.useState([null, null]);

  return (
    <form>
      <div style={{ marginRight: 20, display: "flex" }}>
        <Label>{t("filter_by_date")}</Label>
        <div
          style={{
            display: "flex",
            border: `1px solid rgba(220,223,226,1)`,
            borderRadius: 10,
            lineHeight: 1,
            maxHeight: "2.7em",
          }}
        >
          <LocalizationProvider dateAdapter={DateFnsUtils} locale={he}>
            <StyledMuiDateRangePicker
              sx={{
                "& .MuiPickersDateRangePickerInput-root": {
                  alignItems: "center",
                },
              }}
              startText=""
              endText=""
              mask="__/__/__"
              inputFormat="dd/MM/yy"
              value={selectedDate}
              onChange={(date) => {
                setSelectedDate(date);
                handleDateChange(date);
              }}
              renderInput={(startProps, endProps) => (
                <>
                  <StyledInputDate
                    {...startProps}
                    helperText={null}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      placeholder: null,
                      startAdornment: (
                        <img
                          alt="date"
                          src={dateImg}
                          style={{
                            marginLeft: 5,
                            marginRight: 5,
                          }}
                        />
                      ),
                    }}
                  />
                  <TillDateLabel>{t("till")} </TillDateLabel>
                  <StyledInputDate
                    {...endProps}
                    helperText={null}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      placeholder: "",
                      startAdornment: (
                        <img
                          alt="date"
                          src={dateImg}
                          style={{
                            marginLeft: 5,
                            marginRight: 5,
                          }}
                        />
                      ),
                    }}
                  />
                </>
              )}
            />
          </LocalizationProvider>
        </div>
      </div>
    </form>
  );
};
export default DateRangePicker;
